import React, { useEffect, useState } from "react";
import "./css/about.css";
import aboutImageDefault from "./images/aboutus/about.webp";
import { Link } from "react-router-dom";

const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5000";

const resolveImageUrl = (src, fallback) => {
  if (!src) return fallback;
  if (src.startsWith("http://") || src.startsWith("https://")) return src;
  if (src.startsWith("/uploads/")) return `${API_BASE_URL}${src}`;
  return src;
};

const AboutUs = () => {
  const [content, setContent] = useState({
    subtitle: "من نحن",
    titleLine1: "في نبض كير نقدم حلولاً استشارية مبتكرة",
    titleLine2: "لضمان امتثال ونمو أعمالك",
    descriptionText:
      "نبض كير هي شريكك الموثوق في المملكة العربية السعودية لخدمات هيئة الغذاء والدواء، وزارة الصناعة، والتخليص الجمركي. نتميز بفريق من الخبراء المتخصصين الذين يعملون على تذليل العقبات وتسريع الإجراءات الحكومية لضمان دخول منتجاتك للسوق بأسرع وقت.",
    aboutImageUrl: "",
    badgeLabel: "نسبة رضا العملاء",
    badgeValue: "100%",
    stat1Label: "مشروع ناجح",
    stat1Value: "2.5k+",
    stat2Label: "خبير استشاري",
    stat2Value: "15+",
    stat3Label: "نسبة القبول",
    stat3Value: "100%",
    features: [
      "فريق استشاري محترف",
      "سرعة في الإنجاز",
      "موثوقية وأمان",
      "دقة في التوثيق",
      "دعم مستمر 24/7",
      "ضمان الرضا",
    ],
  });

  useEffect(() => {
    const fetchAbout = async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/api/about`);
        if (!res.ok) return;
        const data = await res.json();
        if (data.about) {
          setContent((prev) => ({
            ...prev,
            ...data.about,
          }));
        }
      } catch {
        // fall back to defaults
      }
    };

    fetchAbout();
  }, []);

  const {
    subtitle,
    titleLine1,
    titleLine2,
    descriptionText,
    aboutImageUrl,
    badgeLabel,
    badgeValue,
    stat1Label,
    stat1Value,
    stat2Label,
    stat2Value,
    stat3Label,
    stat3Value,
    features,
  } = content;

  const imageSrc = resolveImageUrl(aboutImageUrl, aboutImageDefault);
  const featuresList = Array.isArray(features) ? features : [];

  return (
    <section className="about-section">
      <div className="container">
        <div className="row align-items-center">
          {/* Text Content Column (Right in RTL) */}
          <div className="col-lg-6 col-md-12">
            <div className="about-content">
              <div className="about-subtitle">
                <i className="fa-solid fa-building"></i>
                <span>{subtitle}</span>
              </div>

              <h2 className="about-title">
                {titleLine1}
                <br />
                {titleLine2}
              </h2>

              <p className="about-desc">{descriptionText}</p>

              {/* Features List */}
              <div className="about-features">
                {featuresList.map((item, idx) => (
                  <div className="feature-item" key={idx}>
                    <i className="fa-solid fa-circle-check"></i>
                    <span>{item}</span>
                  </div>
                ))}
              </div>

              {/* Stats Cards */}
              <div className="about-stats-container">
                <div className="stat-card">
                  <h3>{stat1Value}</h3>
                  <p>{stat1Label}</p>
                </div>
                <div className="stat-card">
                  <h3>{stat2Value}</h3>
                  <p>{stat2Label}</p>
                </div>
                <div className="stat-card">
                  <h3>{stat3Value}</h3>
                  <p>{stat3Label}</p>
                </div>
              </div>
            </div>
          </div>

          {/* Image Column (Left in RTL) */}
          <div className="col-lg-6 col-md-12">
            <div className="about-image-wrapper">
              <img src={imageSrc} alt="Our Team" className="about-main-img" />

              {/* Floating Badge (Top Right) */}
              <div className="floating-badge">
                <h4>{badgeValue}</h4>
                <span>{badgeLabel}</span>
              </div>

              {/* Floating Button (Bottom Left) */}
              <Link to="/about" className="about-cta-btn">
                المزيد عنا
                <i className="fa-solid fa-arrow-left"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;